export default function () {
  return {
    collection: 'now_options',
    data: [
      { value: '勤務中' },
      { value: 'お昼休憩中' },
      { value: '休暇' },
      { value: '帰宅' },
      { value: 'オフィス' },
      { value: '在宅勤務' },
      { value: '会議中' }
    ]
  }
}
